import apiRequest from "../../helpers/apiRequest";

export default async (slug, obj) => {
    return await apiRequest({
        method: 'put',
        url: `content/update/individual/session/${slug}/`,
        data: obj
    })
}
